import {
    ClinicAccountType,
    ClinicEntityInfo,
    UpdateClinicAccountType,
    userType,
} from "../../DTO";
import { Api } from "../api";

const convertClinicInfo = (data: any): ClinicEntityInfo | null => {
    if (!data) {
        return null;
    }

    return {
        id: data?.id ?? null,
        name: data?.name ?? null,
        firstName: data?.first_name ?? data?.firstName ?? null,
        lastName: data?.last_name ?? data?.lastName ?? null,
        email: data?.email ?? null,
        phone: data?.phone ?? null,
        clinicNumber: data?.clinic_number ?? data?.clinicNumber ?? null,
        doctorName: data?.doctor_name ?? data?.doctorName ?? null,
        ...data,
    };
};

const convertClinicAccount = (data: any): ClinicAccountType => ({
    id: data?.id ?? 0,
    firstName: data?.first_name ?? "",
    lastName: data?.last_name ?? "",
    username: data?.username ?? "",
    email: data?.email ?? "",
    phone: data?.phone ?? "",
    status: data?.status ?? null,
    clinicId: data?.clinic_id ?? null,
    clinic: convertClinicInfo(data?.clinic),
});

export const ShowClinicAccount = (user: userType) => {
    return new Promise<{ account: ClinicAccountType }>((resolve, reject) => {
        const api = new Api({
            method: "get",
            path: "clinic/account",
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) => {
                resolve({
                    account: convertClinicAccount(data?.data ?? data),
                });
            })
            .catch((err: any) => reject(err));
    });
};

export const UpdateClinicAccount = (
    user: userType,
    payload: UpdateClinicAccountType,
) => {
    return new Promise<{ account: ClinicAccountType; message: string }>(
        (resolve, reject) => {
            const api = new Api({
                method: "post",
                path: "clinic/account",
                header: {
                    Authorization: `Bearer ${user.access_token}`,
                },
                body: payload,
                reject422: true,
            });

            return api
                .call()
                .then((data: any) => {
                    resolve({
                        account: convertClinicAccount(data?.data ?? data),
                        message:
                            data?.message || "Clinic account updated successfully.",
                    });
                })
                .catch((err: any) => reject(err));
        },
    );
};
